import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  Alert, Tooltip, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Button, IconButton,
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DownloadIcon from '@mui/icons-material/Download';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import moment from 'moment';
import { apiFetch } from '../services/api';

function ReportPage() {
  const { reportId, '*': extraPath = null } = useParams();
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await apiFetch(`/api/v1/report/${reportId}${extraPath ? `/${extraPath}` : ''}`);
        if (!response.ok) throw new Error("Errore nel recupero dei file");
        const data = await response.json();
        setItems(data.files);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchFiles();
  }, [reportId, extraPath]);

  const handleDownload = async (file) => {
    try {
      const response = await apiFetch(
        `/api/v1/report/${reportId}${extraPath ? `/${extraPath}` : ''}/${file}`,
        { method: 'POST' }
      );
      if (!response.ok) throw new Error('Errore nel download del file');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', file);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err.message);
    }
  };

  const getParentPath = (reportId, path) => {
    if (!path) return '/reports';
    if (path === '/') return `/report/${reportId}`;
    const parts = path.split('/');
    return parts.length > 1
      ? `/report/${reportId}/-/${parts.slice(0, -1).join('/')}`
      : `/report/${reportId}`;
  };

  if (error) return <Alert severity="error">{error}</Alert>;
  if (!items) return <div>Caricamento...</div>;

  return (
    <>
      <TableContainer component={Paper} sx={{ maxWidth: 1024, margin: 'auto', mt: 5 }}>
        <Table aria-label="Lista dei file">
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Size</TableCell>
              <TableCell>Data</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((i) => (
              <TableRow key={`file-${i.file}`} style={{ backgroundColor: i.isDirectory ? '#f0f0f0' : 'inherit' }}>
                <TableCell>
                  {i.isDirectory ? <strong>{i.file}</strong> : i.file}
                </TableCell>
                <TableCell>{!i.isDirectory ? i.size : '-'}</TableCell>
                <TableCell>
                  {!i.isDirectory && (
                    <Tooltip title={moment(i.mtime).format('DD/MM/YYYY HH:mm:ss')}>
                      <span>{moment(i.mtime).fromNow()}</span>
                    </Tooltip>
                  )}
                </TableCell>
                <TableCell>
                  {!i.isDirectory ? (
                    <IconButton aria-label="download" size="small" onClick={() => handleDownload(i.file)}>
                      <DownloadIcon fontSize="small" />
                    </IconButton>
                  ) : (
                    <IconButton
                      aria-label="apri cartella"
                      size="small"
                      component={Link}
                      to={`/report/${reportId}/-${extraPath ? `/${extraPath}` : ''}/${i.file}`}
                    >
                      <ArrowForwardIosIcon fontSize="small" />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button
        variant="outlined"
        color="secondary"
        component={Link}
        size="small"
        to={getParentPath(reportId, extraPath)}
        sx={{ mt: 3 }}
        startIcon={<ArrowBackIosIcon />}
      >
        Torna Indietro
      </Button>
    </>
  );
}

export default ReportPage;
